import { useState, useCallback } from "react";
/**
 * Хук для открытия/закрытия сайдбара
 * @param {boolean} initialState - изначальное состояние модального окна (закрыт)
 * @param {boolean} isModalOpen - текущее состояние модального окна
 */
export const useModal = (initialState = false) => {
  const [isModalOpen, setIsModalOpen] = useState(initialState);

  const open = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const toggle = useCallback(() => {
    setIsModalOpen((prev) => !prev);
  }, []);

  return {
    isModalOpen,
    open,
    close,
    toggle,
  };
};
